<template>
  <section class="upload-box">
    <label :class="{ 'upload-border': isImgShow, 'upload-label': true }">
      <input type="file"
             ref="file"
             accept="image/*"
             @change="getFileUrl" />
      <slot></slot>
    </label>
  </section>
</template>
<script>
import setSignHead from '@/api/setSignHead'
import axios from 'axios'
import { KJUR, hex2b64 } from 'jsrsasign'
import { Toast } from 'vant';

export default {
  props: {
    getImgUrl: {
      type: Function,
      default () {
        return () => { }
      }
    },
    isImgShow: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    getFileUrl () {
      // 显示loading
      const toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '加载中...',
      });
      const userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'))
      const uid = userInfo.uid
      const token = userInfo.token
      // const uid = "1CF85CAAA9274EA2BDDDEAC4A491D71C"
      // const token = '857bee6267f84173808bbd93355e93df'
      const file = this.$refs.file.files[0]
      const filename = file.name
      let sign = 'fileName=' + filename
      const RSA = new KJUR.crypto.Signature({ alg: 'SHA1withRSA', prov: 'cryptojs/jsrsa', prvkeypem: setSignHead.privateKey })
      RSA.updateString(sign)
      sign = RSA.sign()
      sign = hex2b64(sign)
      const params = new FormData()
      params.append('uid', uid)
      params.append('token', token)
      params.append('files', file)
      params.append('fileName', filename)
      params.append('appId', setSignHead.head.appId)
      params.append('deviceType', setSignHead.head.deviceType)
      params.append('sign', sign)
      axios.post('https://miniqrcode.ymdx.cn/AppServerWhpe/com/whpe/fileUpload', params, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(res => {
        Toast.clear();
        if (res.data.respCode === '01') {
          this.getImgUrl(res.data.data.pathList[filename])
        } else {
          this.$eventBus.$emit('getTipsInfo', {
            msg: res.data.respMsg
          })
        }
      }).catch(err => {
        Toast.clear();
        this.$eventBus.$emit('getTipsInfo', {
          msg: err
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.upload-box {
  // margin-bottom: 40px;
  // background: #fff;
  // padding: 40px 0;
  font-size: 0;
  input {
    display: none;
  }
  label {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    // width: 300px;
    // height: 300px;
    &.upload-border {
      // border: 1px solid rgb(76, 152, 254);
      // height: 200px;
      // margin-bottom: 100px;
    }
    img {
      object-fit: contain;
      max-width: 100%;
    }
  }
}
</style>
